
import { RootState } from "redux/store";
import { Link, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getDepartments, updateDepartmentField } from "redux/slices/Departments";
import { Title, ProTable, Modal, SnackBarMessage, SnackBarMessageProps } from "components";
import { updateSupplierField, getSuppliers, deleteSupplier, addSelectedRows, addDeselectedRows, cleanSupplierDetails } from "redux/slices/Suppliers";
import { generalSync } from "redux/slices/Sync";
import { showToast } from "redux/slices/Toasts";

export function Suppliers() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const global = useAppSelector((state: RootState) => state.global);
	const suppliers = useAppSelector((state: RootState) => state.suppliers);
	const storeGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
	const [snackSettings, setSnackSettings] = useState<SnackBarMessageProps>(new SnackBarMessageProps());
	const [showPopup, setShowPopup] = useState<boolean>(false);
	const user = useAppSelector((state: RootState) => state.logedinUser);

	useEffect(() => {
		dispatch(getSuppliers());
	}, []);

	const columns = [
		{
			Header: "Name",
			accessor: "name",
			defaultCanSort: true,
			width: 300,
			Cell: (row: any) => user.permissions.suppliers.canUpdate ? <Link to={`/app/supplier/${row.cell.row.original.id}`}>{row.value}</Link> : <>{row.value}</>,

		},
		{
			Header: "System",
			accessor: "isSystem",
			defaultCanSort: false,
			width: 200,
			Cell: (row: any) => {
				return <>{row.value === true ? "Yes" : "No"}</>;
			}
		},
		{
			Header: "Active",
			accessor: "active",
			defaultCanSort: false,
			width: 900,
			Cell: (row: any) => {
				return <>{row.value === true ? "Yes" : "No"}</>;
			}
		}

	];

	const selectedRows = useCallback((pageIndex: any) => {
		dispatch(updateSupplierField({ key: "selectedRows", value: pageIndex }));
	}, []);


	function handleDeleteSuppliers(deleteCallback: () => void) {
		let ids: number[] = [];
		let systemSuppliersCount = 0;
		suppliers.selectedSupplierRows.flatMap(x => x).forEach((row: any) => {
			console.log(row);
			const foundSupplier = suppliers.table.find(s => s.id === row.id);
			// @ts-ignore
			if(foundSupplier) {
				if (foundSupplier.isSystem === false) {
					// @ts-ignore
					ids.push(foundSupplier.id);
				} else {
					systemSuppliersCount++;
				}
			}
		});
		if(ids.length > 0) {
			dispatch(deleteSupplier({
				ids: ids,
			})).then((res: any) => {
				deleteCallback();
				dispatch(cleanSupplierDetails());
				dispatch(getSuppliers());
			});
		} else {
			deleteCallback();
			dispatch(cleanSupplierDetails());
		}

		if (systemSuppliersCount) {
			dispatch(showToast({ value: [`Could not delete ${systemSuppliersCount} system suppliers.`] }));
		}

		dispatch(getSuppliers());
	}

	function Sync() {
		dispatch(generalSync({ suppliers: true })).then((res) => {
			if (res.data) {
				dispatch(showToast({ value: ["Sync Completed"] }))
			} else {
				dispatch(showToast({ value: ["Sync Failed"] }))
			}
		})
	}

	function onSearchClick(keyword?: string) {
		console.log(keyword)
		dispatch(getSuppliers(keyword));
	}

	function updateTableRows(dataTableState: any) {

	}

	function selectedRowsUpdate(rows: any, index: any) {
		dispatch(addSelectedRows({ rows: rows, index: index }));
	}

	function deselectedRowsUpdate(rows: any, index: any) {
		dispatch(addDeselectedRows({ rows: rows, index: index }));
	}

	return (
		<>
			<Title pageTitle="Suppliers" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<ProTable
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSelectable={true}
										isSearchable={true}
										onSearchClick={onSearchClick}
										table={suppliers.table}
										columns={columns}
										data={suppliers}
										errors={suppliers.error}
										loading={suppliers.loading}
										selectedRows={suppliers.selectedSupplierRows}
										deselectedRows={suppliers.deselectedSupplierRows}
										reloadTableRows={() => dispatch(getSuppliers())}
										syncOptions={() => setShowPopup(true)}
										addNewRow={user.permissions.suppliers.canCreate ? () => navigate("/app/supplier/new") : undefined }
										removeRows={user.permissions.suppliers.canDelete ? handleDeleteSuppliers : undefined}
										updateTableRows={updateTableRows}
										selectedRowsUpdate={selectedRowsUpdate}
									/>
								</div>
								<SnackBarMessage {...snackSettings} />
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			<Modal
				show={showPopup}
				title="Manual Sync"
				description="Do you want to resync all Suppliers?"
				buttonText="Sync"
				buttonType="primary"
				handleClose={() => setShowPopup(false)}
				handleSubmit={() => {
					setShowPopup(false);
					Sync();
				}}
			/>
		</>
	);
}